import { render, staticRenderFns } from "./MerchantKyc.vue?vue&type=template&id=eef22a90&scoped=true"
import script from "./MerchantKyc.vue?vue&type=script&lang=js"
export * from "./MerchantKyc.vue?vue&type=script&lang=js"
import style0 from "./MerchantKyc.vue?vue&type=style&index=0&id=eef22a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef22a90",
  null
  
)

export default component.exports